var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1409 13.5648V19.2283C17.1409 21.6871 15.5018 23.3157 13.0535 23.3157H6.51784C4.06959 23.3157 2.43042 21.6871 2.43042 19.2283V11.064C2.43042 8.60523 4.06959 6.97656 6.51784 6.97656H10.5422C11.6245 6.97656 12.6647 7.40737 13.4318 8.17442L15.9431 10.6752C16.7101 11.4423 17.1409 12.4825 17.1409 13.5648Z",
    fill: "url(#paint0_linear_3801_15789)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4455 8.89949V14.563C23.4455 17.0113 21.8063 18.6505 19.3581 18.6505H18.1917V13.5648C18.1917 12.2094 17.6453 10.8854 16.6891 9.92923L14.1779 7.42844C13.2217 6.47226 11.8977 5.92587 10.5423 5.92587H8.75598C8.94512 3.74031 10.5317 2.30078 12.8224 2.30078H16.8468C17.929 2.30078 18.9693 2.73159 19.7363 3.49864L22.2476 6.00993C23.0147 6.77698 23.4455 7.81722 23.4455 8.89949Z",
    fill: "url(#paint1_linear_3801_15789)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3801_15789",
    x1: 9.78567,
    y1: 6.97656,
    x2: 9.78567,
    y2: 23.3157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3801_15789",
    x1: 16.1007,
    y1: 2.30078,
    x2: 16.1007,
    y2: 18.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPast);
export default __webpack_public_path__ + "static/media/copy-past.604eeeb4c24e6bcf4a7fc95c975971d0.svg";
export { ForwardRef as ReactComponent };